// @flow

import React from 'react';
import type { Node } from 'react';
import styled from 'styled-components';
import { flex } from 'styles';

const Wrapper = styled.section`
  ${flex('center')};
  flex-direction: column;
  margin-top: 75px;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const DisclaimerContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 32px;
  font-size: 1.2rem;
`;

const Content = styled.div`
  margin-bottom: 32px;
`;

const HeaderContainer = styled.div`
  margin-bottom: 32px;
  text-align: center;
`;

type Props = {
  children: Node,
  buttons?: Node,
  title: Node,
  disclaimer?: Node | string,
};

const CenteredLayoutWrapper = ({ children, buttons, title, disclaimer, ...rest }: Props) => (
  <Wrapper {...rest}>
    <HeaderContainer>{title}</HeaderContainer>
    <Content>{children}</Content>
    <ButtonContainer>{buttons}</ButtonContainer>
    <DisclaimerContainer>{disclaimer}</DisclaimerContainer>
  </Wrapper>
);

export default CenteredLayoutWrapper;
